import React from 'react'
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom'
import Navigation from './components/Navigation'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import HomePage from './pages/HomePage'
import ActivitiesPage from './pages/ActivitiesPage'
import PricingPage from './pages/PricingPage'
import DashboardPage from './pages/DashboardPage'
import ProfessionalsPage from './pages/ProfessionalsPage'
import ProfilePage from './pages/ProfilePage'
import LoginPage from './pages/LoginPage'
import RegisterPage from './pages/RegisterPage'
import AdminFinancePage from './pages/AdminFinancePage'
import AdminOperationsPage from './pages/AdminOperationsPage'
import LearningStudioPage from './pages/LearningStudioPage'
import SupportPage from './pages/SupportPage'
import VideoCallPage from './pages/VideoCallPage'
import FAQPage from './pages/FAQPage'
import PWAStatus from './components/PWAStatus'
import './styles/globals.css'

function AppRoutes() {
  const { user, setUser, loading } = useAuth()

  if (loading) return <div className="loading-screen">Carregando plataforma...</div>

  return (
    <Router>
      <div className="app-shell">
        <PWAStatus />
        <Navigation />
        <main className="main-shell">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/atividades" element={<ActivitiesPage />} />
            <Route path="/planos" element={<PricingPage user={user} />} />
            <Route path="/estudio" element={<LearningStudioPage user={user} />} />
            <Route path="/suporte" element={<SupportPage user={user} />} />
            <Route path="/atendimento-online" element={<SupportPage user={user} />} />
            <Route path="/profissionais" element={<ProfessionalsPage user={user} />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/videochamada/:appointmentId" element={user ? <VideoCallPage user={user} /> : <Navigate to="/login" />} />
            <Route path="/dashboard" element={user ? <DashboardPage user={user} /> : <Navigate to="/login" />} />
            <Route path="/perfil" element={user ? <ProfilePage user={user} setUser={setUser} /> : <Navigate to="/login" />} />
            <Route path="/login" element={user ? <Navigate to="/dashboard" /> : <LoginPage setUser={setUser} />} />
            <Route path="/registrar" element={user ? <Navigate to="/dashboard" /> : <RegisterPage setUser={setUser} />} />
            <Route path="/admin/financeiro" element={user?.userType === 'admin' ? <AdminFinancePage user={user} /> : <Navigate to={user ? '/dashboard' : '/login'} />} />
            <Route path="/admin/operacoes" element={user?.userType === 'admin' ? <AdminOperationsPage /> : <Navigate to={user ? '/dashboard' : '/login'} />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <footer className="app-footer">
          <div className="footer-shell">
            <p>© 2026 Math.Kids • matemática adaptada, programação e games.</p>
          </div>
        </footer>
      </div>
    </Router>
  )
}

export default function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  )
}
